/* GCCV V3.1: typed choices, intent safeguards, consent cleanup and enquiry context. */
(function (global) {
  'use strict';
  const api = global.GCCVChatbot;
  if (!api || api.qualityVersion) return;
  api.qualityVersion = '3.1';
  const welcome = 'Hi, I’m Josh, the Gold Coast Campervans virtual assistant. What can we help you with today?';
  const proto = api.Engine.prototype;
  const original = {answer:proto.answer, choose:proto.choose, view:proto.view, summary:proto.summary, faq:proto.faq};
  const normalise = s => String(s || '').trim().toLowerCase().replace(/[’‘]/g, "'").replace(/[.!?]+$/, '');
  const noAction = /\b(?:(?:don't|do not)\s+(?:(?:want|need)\s+(?:you\s+)?to\s+)?(?:call|book|buy|quote)|not ready(?: to (?:book|buy|start))?|just browsing|just looking)\b/i;
  const hot = /\b(?:quote(?: me)?|call me|call back|callback|ready to (?:book|buy|start)|book (?:me|a build|it|in)|go ahead|when can (?:you|we) start|earliest (?:date|availability)|check (?:your )?availability)\b/i;
  proto.nextLead = function () {
    const fields = ['name','phone','email','vehicle','budget','timeline','photos'];
    const next = fields.find(k => !this.data[k] || (k === 'phone' && !this.validPhone(this.data[k])) || (k === 'email' && !this.validEmail(this.data[k])));
    this.state = next ? 'lead-' + next : 'review';
  };
  proto.answer = function (raw) {
    const text = String(raw || '').trim().slice(0,1600);
    if (!text) return this.view();
    const norm = normalise(text);
    const choice = (this.view().choices || []).find(o => normalise(o.value) === norm || normalise(o.label) === norm);
    if (choice) return this.choose(choice.value);
    const identityField = ['lead-name','lead-phone','lead-email','photo-link','vehicle-link','recent-link'].includes(this.state);
    const isQuestion = /^(?:what|how|does|do |can |could |is |are |tell |explain |warranty$|engineering$|price$)/i.test(text) || text.endsWith('?');
    if (noAction.test(norm)) {
      this.note = 'No problem. You can browse without requesting a quote or callback. Use the main menu whenever you like.';
      return this.view();
    }
    if ((!identityField || isQuestion || /\b(?:call me|call back|callback|get a quote|quote me|ready to book)\b/i.test(text)) && hot.test(norm)) {
      this.data.customerQuestion = text;
      this.start(/\b(?:call me|call back|callback)\b/i.test(norm) ? 'callback' : 'quote');
      const intent = api.detectIntent(text);
      if (['warranty','engineering'].includes(intent)) return this.faq(intent);
      return this.view();
    }
    const intent = api.detectIntent(text);
    if (isQuestion && ['warranty','engineering','price'].includes(intent)) return this.faq(intent);
    const view = this.view();
    if (!view.input) this.data.customerQuestion = text;
    return original.answer.call(this,text);
  };
  proto.choose = function (value) {
    if (this.state === 'home' && api.MENUS.some(o => o[0] === value)) return this.start(value);
    const state = this.state;
    original.choose.call(this,value);
    if (state === 'finance-consent' && value === 'no') this.data.request = 'Finance information only — no NJS referral';
    if (state === 'hiace-series' && value === 'Not sure yet') this.data.vehicle = 'Toyota HiAce — series not yet confirmed';
    if (state === 'parts-next' && value === 'install') this.data.topic = 'Parts plus install';
    if (state === 'poptop-condition' && value === 'Not sure') this.note = 'Our team will need to check the van and photos before confirming the work and price. Extra work may apply if it is already fitted out.';
    return this.view();
  };
  proto.faq = function (intent) {
    if (intent === 'price' && this.data.route === 'poptop') {
      this.note = this.data.condition === 'Empty van' ? 'For an empty van, a pop-top starts from around $11,500, depending on the vehicle and confirmation by our team.' : 'We need to check the vehicle and whether it is already fitted out before confirming a pop-top price. Extra work may apply; photos help our team assess it.';
      return this.view();
    }
    return original.faq.call(this,intent);
  };
  proto.summary = function () {
    return original.summary.call(this) + (this.data.customerQuestion ? '\nCustomer question: ' + this.data.customerQuestion : '');
  };
  proto.view = function () {
    const view = original.view.call(this);
    if (this.state === 'home') view.text = welcome;
    if (this.state === 'lead-name') view.note = [view.note, 'Your details are sent to our team only when you select Send my enquiry. Please do not enter payment details or identification documents.'].filter(Boolean).join('\n\n');
    return view;
  };
  // The base script may mount before this deferred enhancement loads.
  // Update only the original welcome message, never an in-progress question.
  if (typeof document !== 'undefined') {
    const firstMessage = document.querySelector('#gccv-chatbot .gccv-question');
    if (firstMessage && firstMessage.textContent === 'Hi, I’m the Gold Coast Campervans website assistant. What can we help you with today?') firstMessage.textContent = welcome;
  }
})(globalThis);
